"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToOrderHistory = exports.subscribeToMarginCancelOrderLiquidationEvents = exports.resetActivePage = exports.requestTradeReports = exports.requestOpenOrdersNextPage = exports.requestOpenOrders = exports.requestInactiveOrders = exports.requestAccountTradesNextPage = exports.requestAccountTrades = exports.removeActiveRequest = exports.receiveTradeReports = exports.receiveTradeHistory = exports.receiveOpenOrdersNextPage = exports.receiveOpenOrders = exports.receiveInactiveOrders = exports.receiveAccountTradesNextPage = exports.receiveAccountTradesForOrderId = exports.receiveAccountTrades = exports.getRecentActivity = exports.getOrders = exports.getOpenTradeReports = exports.getOpenOrders = exports.getInactiveOrders = exports.getAccountTrades = exports.cancelSellOrders = exports.cancelOrders = exports.cancelBuyOrders = exports.cancelAllOrders = exports.addOpenOrder = exports.addInactiveOrder = exports.addAccountTrade = exports.REQUEST_TRADE_REPORTS_NEXT_PAGE = exports.REQUEST_TRADE_REPORTS = exports.REQUEST_RECENT_ACTIVITY = exports.REQUEST_OPEN_ORDERS_NEXT_PAGE = exports.REQUEST_OPEN_ORDERS = exports.REQUEST_INACTIVE_ORDERS_NEXT_PAGE = exports.REQUEST_INACTIVE_ORDERS = exports.REQUEST_ACCOUNT_TRADES_NEXT_PAGE = exports.REQUEST_ACCOUNT_TRADES = exports.REMOVE_ACTIVE_REQUEST = exports.RECEIVE_TRADE_REPORTS_NEXT_PAGE = exports.RECEIVE_TRADE_REPORTS = exports.RECEIVE_TRADE_HISTORY = exports.RECEIVE_RECENT_ACTIVITY = exports.RECEIVE_OPEN_ORDERS_NEXT_PAGE = exports.RECEIVE_OPEN_ORDERS = exports.RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = exports.RECEIVE_INACTIVE_ORDERS = exports.RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = exports.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = exports.RECEIVE_ACCOUNT_TRADES = exports.FetchAccountTradesForOrderId = exports.ADD_OPEN_ORDER = exports.ADD_INACTIVE_ORDER = exports.ADD_ACCOUNT_TRADE = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _apiActions = require("./apiActions");
var _orderStateSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/orderStateSubscriptionService"));
var _orderTradesSuscriptionService = _interopRequireDefault(require("../../services/subscriptions/orderTradesSuscriptionService"));
var _marginCancelOrderLiquidationEventSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/marginCancelOrderLiquidationEventSubscriptionService"));
var _placeOrderHelper = require("../../helpers/placeOrderHelper");
var _orderEntryActions = require("./orderEntryActions");
var _snackbarActions = require("./snackbarActions");
var _paginationActions = require("./paginationActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ADD_OPEN_ORDER = exports.ADD_OPEN_ORDER = 'ADD_OPEN_ORDER';
var RECEIVE_OPEN_ORDERS = exports.RECEIVE_OPEN_ORDERS = 'RECEIVE_OPEN_ORDERS';
var REQUEST_OPEN_ORDERS = exports.REQUEST_OPEN_ORDERS = 'REQUEST_OPEN_ORDERS';
var RECEIVE_OPEN_ORDERS_NEXT_PAGE = exports.RECEIVE_OPEN_ORDERS_NEXT_PAGE = 'RECEIVE_OPEN_ORDERS_NEXT_PAGE';
var REQUEST_OPEN_ORDERS_NEXT_PAGE = exports.REQUEST_OPEN_ORDERS_NEXT_PAGE = 'REQUEST_OPEN_ORDERS_NEXT_PAGE';
var ADD_ACCOUNT_TRADE = exports.ADD_ACCOUNT_TRADE = 'ADD_ACCOUNT_TRADE';
var RECEIVE_ACCOUNT_TRADES = exports.RECEIVE_ACCOUNT_TRADES = 'RECEIVE_ACCOUNT_TRADES';
var REQUEST_ACCOUNT_TRADES = exports.REQUEST_ACCOUNT_TRADES = 'REQUEST_ACCOUNT_TRADES';
var RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = exports.RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = 'RECEIVE_ACCOUNT_TRADES_NEXT_PAGE';
var REQUEST_ACCOUNT_TRADES_NEXT_PAGE = exports.REQUEST_ACCOUNT_TRADES_NEXT_PAGE = 'REQUEST_ACCOUNT_TRADES_NEXT_PAGE';
var ADD_INACTIVE_ORDER = exports.ADD_INACTIVE_ORDER = 'ADD_INACTIVE_ORDER';
var RECEIVE_INACTIVE_ORDERS = exports.RECEIVE_INACTIVE_ORDERS = 'RECEIVE_INACTIVE_ORDERS';
var REQUEST_INACTIVE_ORDERS = exports.REQUEST_INACTIVE_ORDERS = 'REQUEST_INACTIVE_ORDERS';
var RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = exports.RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = 'RECEIVE_INACTIVE_ORDERS_NEXT_PAGE';
var REQUEST_INACTIVE_ORDERS_NEXT_PAGE = exports.REQUEST_INACTIVE_ORDERS_NEXT_PAGE = 'REQUEST_INACTIVE_ORDERS_NEXT_PAGE';
var RECEIVE_TRADE_REPORTS = exports.RECEIVE_TRADE_REPORTS = 'RECEIVE_TRADE_REPORTS';
var REQUEST_TRADE_REPORTS = exports.REQUEST_TRADE_REPORTS = 'REQUEST_TRADE_REPORTS';
var RECEIVE_TRADE_REPORTS_NEXT_PAGE = exports.RECEIVE_TRADE_REPORTS_NEXT_PAGE = 'RECEIVE_TRADE_REPORTS_NEXT_PAGE';
var REQUEST_TRADE_REPORTS_NEXT_PAGE = exports.REQUEST_TRADE_REPORTS_NEXT_PAGE = 'REQUEST_TRADE_REPORTS_NEXT_PAGE';
var RECEIVE_TRADE_HISTORY = exports.RECEIVE_TRADE_HISTORY = 'RECEIVE_TRADE_HISTORY';
var RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = exports.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = 'RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID';
var REMOVE_ACTIVE_REQUEST = exports.REMOVE_ACTIVE_REQUEST = 'REMOVE_ACTIVE_REQUEST';
var REQUEST_RECENT_ACTIVITY = exports.REQUEST_RECENT_ACTIVITY = 'REQUEST_RECENT_ACTIVITY';
var RECEIVE_RECENT_ACTIVITY = exports.RECEIVE_RECENT_ACTIVITY = 'RECEIVE_RECENT_ACTIVITY';
var getOpenOrders = exports.getOpenOrders = function getOpenOrders(AccountId, OMSID, Limit, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch) {
      var openOrdersCall, openOrders, openOrdersNextPage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            openOrdersCall = function openOrdersCall(_ref2) {
              var index = _ref2.index;
              return dispatch((0, _apiActions.callAPI)('GetOpenOrders', {
                AccountId: AccountId,
                OMSID: OMSID,
                Limit: Limit,
                StartIndex: index
              }));
            };
            dispatch(requestOpenOrders({
              StartIndex: StartIndex
            }));
            dispatch(requestOpenOrdersNextPage());
            _context.next = 5;
            return openOrdersCall({
              index: StartIndex
            });
          case 5:
            openOrders = _context.sent;
            _context.next = 8;
            return openOrdersCall({
              index: Limit + StartIndex
            });
          case 8:
            openOrdersNextPage = _context.sent;
            dispatch(receiveOpenOrders(openOrders));
            dispatch(receiveOpenOrdersNextPage(openOrdersNextPage));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var subscribeToOrderHistory = exports.subscribeToOrderHistory = function subscribeToOrderHistory() {
  return function (dispatch, getState) {
    _orderStateSubscriptionService["default"].subscribe(function (x) {
      if (['Working'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addOpenOrder(x));
        if (getState().form.buySell) {
          dispatch((0, _orderEntryActions.showBuySellSuccessMessage)());
        }
      } else if (['Rejected', 'Canceled', 'FullyExecuted'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addInactiveOrder(x));
        if (getState().form.buySell) {
          if (x.OrderState === 'FullyExecuted') {
            dispatch((0, _orderEntryActions.showBuySellSuccessMessage)());
          } else {
            dispatch((0, _orderEntryActions.showBuySellFailMessage)());
          }
        }
      }
      if (x.CancelReason !== 'SystemCanceled_Liquidation' && x.CancelReason !== 'UserModified') {
        var snackBar = (0, _placeOrderHelper.getOrderEventSnackbar)(x);
        dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBar), {}, {
          id: snackBar.id || 'OrderStateEventSnackbar'
        })));
      }
    });
    _orderTradesSuscriptionService["default"].subscribe(function (x) {
      dispatch(addAccountTrade(x));
    });
  };
};
var subscribeToMarginCancelOrderLiquidationEvents = exports.subscribeToMarginCancelOrderLiquidationEvents = function subscribeToMarginCancelOrderLiquidationEvents() {
  return function (dispatch, getState) {
    _marginCancelOrderLiquidationEventSubscriptionService["default"].subscribe(function (x) {
      if (x.LiquidationEventType == 'CancelOrderEvent') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'MarginCancelOrderAccountLiquidation',
          text: 'Your {{InstrumentSymbol}} {{Side, lowercase}} {{OrderType}} order has been canceled due to account liquidation.',
          type: 'warning',
          textVars: _objectSpread(_objectSpread({}, x), {}, {
            ns: 'margin',
            InstrumentSymbol: getState().apexCore.instrument.instruments.find(function (i) {
              return i.InstrumentId === x.InstrumentId;
            }).Symbol
          })
        }));
      }
    });
  };
};
var getAccountTrades = exports.getAccountTrades = function getAccountTrades(AccountId, OMSId) {
  var Count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var StartIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch) {
      var accountTradesCall, trades, tradesNextPage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            accountTradesCall = function accountTradesCall(_ref4) {
              var index = _ref4.index;
              return dispatch((0, _apiActions.callAPI)('GetAccountTrades', {
                AccountId: AccountId,
                OMSId: OMSId,
                Count: Count,
                StartIndex: index
              }));
            };
            dispatch(requestAccountTrades({
              StartIndex: StartIndex
            }));
            dispatch(requestAccountTradesNextPage());
            _context2.next = 5;
            return accountTradesCall({
              index: StartIndex
            });
          case 5:
            trades = _context2.sent;
            _context2.next = 8;
            return accountTradesCall({
              index: StartIndex + Count
            });
          case 8:
            tradesNextPage = _context2.sent;
            dispatch(receiveAccountTrades(trades));
            dispatch(receiveAccountTradesNextPage(tradesNextPage));
            dispatch(receiveTradeHistory(trades));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var resetActivePage = exports.resetActivePage = function resetActivePage(componentName) {
  return function (dispatch) {
    return dispatch((0, _paginationActions.setActivePage)({
      componentName: componentName,
      activePage: 0
    }));
  };
};
var requestRecentActivity = function requestRecentActivity(payload) {
  return {
    type: REQUEST_RECENT_ACTIVITY,
    payload: payload
  };
};
var receiveRecentActivity = function receiveRecentActivity(payload) {
  return {
    type: RECEIVE_RECENT_ACTIVITY,
    payload: payload
  };
};
var getRecentActivity = exports.getRecentActivity = function getRecentActivity() {
  var Depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  var StartIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ProductId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var _getState$user, AccountId, userInfo, OMSId, TransactionReferenceTypes, filterState, StartTimestamp, StartDate, EndTimestamp, EndDate, trades;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _getState$user = getState().user, AccountId = _getState$user.selectedAccountId, userInfo = _getState$user.userInfo;
            OMSId = userInfo.OMSId;
            dispatch(requestRecentActivity({
              StartIndex: StartIndex
            }));
            TransactionReferenceTypes = ['1', '2', '3'];
            filterState = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'type'], 'all');
            if (filterState !== 'all') {
              if (filterState === 'trades') {
                TransactionReferenceTypes = ['1'];
              }
              if (filterState === 'withdraw') {
                TransactionReferenceTypes = ['3'];
              }
              if (filterState === 'deposit') {
                TransactionReferenceTypes = ['2'];
              }
            }
            StartDate = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'startDate']);
            if (StartDate && typeof StartDate !== 'string') {
              StartTimestamp = StartDate.getTime();
            }
            EndDate = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'endDate']);
            if (EndDate && typeof EndDate !== 'string') {
              EndTimestamp = EndDate.getTime();
            }
            _context3.next = 12;
            return dispatch((0, _apiActions.callAPI)('GetAccountTransactions', {
              AccountId: AccountId,
              OMSId: OMSId,
              Depth: Depth,
              StartIndex: StartIndex,
              ProductId: ProductId,
              TransactionReferenceTypes: TransactionReferenceTypes,
              StartTimestamp: StartTimestamp,
              EndTimestamp: EndTimestamp
            }));
          case 12:
            trades = _context3.sent;
            dispatch(receiveRecentActivity({
              data: trades
            }));
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var FetchAccountTradesForOrderId = exports.FetchAccountTradesForOrderId = function FetchAccountTradesForOrderId(OrderId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var _getState, user, AccountId, trades;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _getState = getState(), user = _getState.user;
            AccountId = user.accounts[0].AccountId;
            _context4.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetAccountTrades', {
              AccountId: AccountId,
              OrderId: OrderId,
              OMSID: 1
            }));
          case 4:
            trades = _context4.sent;
            dispatch(receiveAccountTradesForOrderId(trades));
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var getInactiveOrders = exports.getInactiveOrders = function getInactiveOrders(AccountId, OMSId, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch) {
      var orderHistoryCall, orders;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            orderHistoryCall = function orderHistoryCall(_ref8) {
              var index = _ref8.index;
              return dispatch((0, _apiActions.callAPI)('GetOrderHistory', {
                AccountId: AccountId,
                OMSId: OMSId,
                StartIndex: index
              }));
            };
            dispatch(requestInactiveOrders({
              StartIndex: StartIndex
            }));
            _context5.next = 4;
            return orderHistoryCall({
              index: StartIndex
            });
          case 4:
            orders = _context5.sent;
            dispatch(receiveInactiveOrders(orders));
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var getOrders = exports.getOrders = function getOrders(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch) {
      var Depth, orders;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch(requestInactiveOrders({}));
            Depth = 1000;
            _context6.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetOrders', {
              AccountId: AccountId,
              OMSId: OMSId,
              Depth: Depth
            }));
          case 4:
            orders = _context6.sent;
            dispatch(receiveInactiveOrders(orders));
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x8) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var removeActiveRequest = exports.removeActiveRequest = function removeActiveRequest() {
  return {
    type: REMOVE_ACTIVE_REQUEST
  };
};
var getOpenTradeReports = exports.getOpenTradeReports = function getOpenTradeReports(AccountId, OMSId, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch) {
      var tradeReportsCall, tradeReports;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            tradeReportsCall = function tradeReportsCall(_ref11) {
              var StartIndex = _ref11.StartIndex;
              return dispatch((0, _apiActions.callAPI)('GetOpenTradeReports', {
                AccountId: AccountId,
                OMSId: OMSId,
                StartIndex: StartIndex
              }));
            };
            dispatch(requestTradeReports({
              StartIndex: StartIndex
            }));
            _context7.next = 4;
            return tradeReportsCall({
              StartIndex: StartIndex
            });
          case 4:
            tradeReports = _context7.sent;
            dispatch(receiveTradeReports(tradeReports));
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var receiveOpenOrders = exports.receiveOpenOrders = function receiveOpenOrders(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS,
    payload: payload
  };
};
var requestOpenOrders = exports.requestOpenOrders = function requestOpenOrders(payload) {
  return {
    type: REQUEST_OPEN_ORDERS,
    payload: payload
  };
};
var receiveOpenOrdersNextPage = exports.receiveOpenOrdersNextPage = function receiveOpenOrdersNextPage(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS_NEXT_PAGE,
    payload: payload
  };
};
var requestOpenOrdersNextPage = exports.requestOpenOrdersNextPage = function requestOpenOrdersNextPage(payload) {
  return {
    type: REQUEST_OPEN_ORDERS_NEXT_PAGE,
    payload: payload
  };
};
var addOpenOrder = exports.addOpenOrder = function addOpenOrder(payload) {
  return {
    type: ADD_OPEN_ORDER,
    payload: payload
  };
};
var addInactiveOrder = exports.addInactiveOrder = function addInactiveOrder(payload) {
  return {
    type: ADD_INACTIVE_ORDER,
    payload: payload
  };
};
var receiveAccountTrades = exports.receiveAccountTrades = function receiveAccountTrades(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES,
    payload: payload
  };
};
var receiveAccountTradesNextPage = exports.receiveAccountTradesNextPage = function receiveAccountTradesNextPage(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_NEXT_PAGE,
    payload: payload
  };
};
var receiveAccountTradesForOrderId = exports.receiveAccountTradesForOrderId = function receiveAccountTradesForOrderId(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID,
    payload: payload
  };
};
var requestAccountTrades = exports.requestAccountTrades = function requestAccountTrades(payload) {
  return {
    type: REQUEST_ACCOUNT_TRADES,
    payload: payload
  };
};
var requestAccountTradesNextPage = exports.requestAccountTradesNextPage = function requestAccountTradesNextPage(payload) {
  return {
    type: REQUEST_ACCOUNT_TRADES_NEXT_PAGE,
    payload: payload
  };
};
var addAccountTrade = exports.addAccountTrade = function addAccountTrade(payload) {
  return {
    type: ADD_ACCOUNT_TRADE,
    payload: payload
  };
};
var receiveInactiveOrders = exports.receiveInactiveOrders = function receiveInactiveOrders(payload) {
  return {
    type: RECEIVE_INACTIVE_ORDERS,
    payload: payload
  };
};
var requestInactiveOrders = exports.requestInactiveOrders = function requestInactiveOrders(payload) {
  return {
    type: REQUEST_INACTIVE_ORDERS,
    payload: payload
  };
};
var receiveTradeReports = exports.receiveTradeReports = function receiveTradeReports(payload) {
  return {
    type: RECEIVE_TRADE_REPORTS,
    payload: payload
  };
};
var requestTradeReports = exports.requestTradeReports = function requestTradeReports(payload) {
  return {
    type: REQUEST_TRADE_REPORTS,
    payload: payload
  };
};
var receiveTradeHistory = exports.receiveTradeHistory = function receiveTradeHistory(payload) {
  return {
    type: RECEIVE_TRADE_HISTORY,
    payload: payload
  };
};
var cancelAllOrders = exports.cancelAllOrders = function cancelAllOrders() {
  return function (dispatch, getState) {
    var OMSId = getState().user.userInfo.OMSId;
    var selectedAccountId = getState().user.selectedAccountId;
    var selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
    dispatch((0, _apiActions.callAPI)('CancelAllOrders', {
      OMSId: OMSId,
      AccountId: selectedAccountId,
      InstrumentId: selectedInstrumentId
    })).then(function () {
      return dispatch((0, _snackbarActions.showSnack)({
        id: 'cancelAllOrdersSuccessSnack',
        text: "All orders cancelled",
        type: 'success'
      }));
    });
  };
};
var cancelSellOrders = exports.cancelSellOrders = function cancelSellOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Sell');
  };
};
var cancelBuyOrders = exports.cancelBuyOrders = function cancelBuyOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Buy');
  };
};
var cancelOrders = exports.cancelOrders = function cancelOrders(OrderIds) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var OMSId, selectedAccountId, cancelOrderPromises;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            selectedAccountId = getState().user.selectedAccountId;
            if (!(OrderIds.length > 1)) {
              _context8.next = 13;
              break;
            }
            cancelOrderPromises = OrderIds.map(function (orderId) {
              dispatch((0, _apiActions.callAPI)('CancelOrder', {
                OrderId: orderId,
                AccountId: selectedAccountId,
                OMSId: OMSId
              }));
            });
            _context8.next = 6;
            return Promise.all(cancelOrderPromises);
          case 6:
            _context8.next = 8;
            return dispatch(getOpenOrders(selectedAccountId, OMSId));
          case 8:
            _context8.next = 10;
            return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
          case 10:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelOrderSuccessSnack',
              // t('Orders {{n}} cancelled')
              text: "Orders {{n}} cancelled",
              textVars: {
                n: OrderIds.toString()
              },
              type: 'success'
            }));
            _context8.next = 20;
            break;
          case 13:
            _context8.next = 15;
            return dispatch((0, _apiActions.callAPI)('CancelOrder', {
              OrderId: OrderIds[0],
              AccountId: selectedAccountId,
              OMSId: OMSId
            }));
          case 15:
            _context8.next = 17;
            return dispatch(getOpenOrders(selectedAccountId, OMSId));
          case 17:
            _context8.next = 19;
            return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
          case 19:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelOrderSuccessSnack',
              // t('Order {{n}} cancelled')
              text: "Order {{n}} cancelled",
              textVars: {
                n: OrderIds[0]
              },
              type: 'success'
            }));
          case 20:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x10, _x11) {
      return _ref12.apply(this, arguments);
    };
  }();
};
function cancelSideOrders(dispatch, getState, side) {
  var openOrders = getState().apexCore.orderHistory.openOrders;
  var OMSId = getState().user.userInfo.OMSId;
  var selectedAccountId = getState().user.selectedAccountId;
  var sideOrderIds = openOrders.filter(function (order) {
    return order.Side === side;
  }).map(function (order) {
    return order.OrderId;
  });
  sideOrderIds.forEach(function (OrderId) {
    dispatch((0, _apiActions.callAPI)('CancelOrder', {
      OrderId: OrderId,
      AccountId: selectedAccountId,
      OMSId: OMSId
    }));
  });
  if (side === 'Buy') {
    dispatch((0, _snackbarActions.showSnack)({
      id: 'cancelBuyOrdersSuccessSnack',
      text: "Buy orders cancelled",
      type: 'success'
    }));
  } else {
    dispatch((0, _snackbarActions.showSnack)({
      id: 'cancelSellOrdersSuccessSnack',
      text: "Sell orders cancelled",
      type: 'success'
    }));
  }
}